import React, { useRef, useState, useEffect, useContext, useMemo } from "react";
import { withTranslation } from "react-i18next";
import { ToastComponent } from "@syncfusion/ej2-react-notifications";
import { cicassService, auth } from "../../../_services";
import { CircularProgress, Paper, Box, Grid, IconButton, Tooltip, Alert } from "@mui/material";
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import ResponsiveCalendarDay from './components/ResponsiveCalendarDay';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Button } from "@mui/material";
import AssignmentsSidePanel from './components/AssignmentsSidePanel';
import ChangeShiftStepperPlus from "./components/ChangeShiftStepperPlus";
import TokenContext from "components/TokenContext";
import ShiftAssignDialog from "./components/ShiftAssignDialog";
import "./calendar.css";
import SummaryDialog112 from './components/SummaryDialog112';
import ShiftTransferDialog from "./components/ShiftTransferDialog";
import ShiftRequestsDialog from "./components/ShiftRequestsDialog";
import VacantShiftsAdminDialog from "./components/VacantShiftsAdminDialog";
import VacantApplyDialog from "./components/VacantApplyDialog";
import VacantCancelDialog from "./components/VacantCancelDialog";
import { config } from "_helpers";
import ShiftUserSelect from "./components/ShiftUserSelect"; // Estratto in un file dedicato
import CalendarToolbar from "./components/CalendarToolbar";
import ShiftChangeDialog from "./components/ShiftChangeDialog";
import eventBus from "../../../_utils/eventBus"; 

const apiUrl = "shift";
const apiUrlCalShift = "ana_calendar_shift/calendar/";
const apiUrlShift = "shift/calendarxls";
const apiUrlLastUpdate = "shift/lastupdate";
const apiUrDayCombo = "ana_day/combo";
const apiUrlAvailability = "ana_calendar/availability/";
const apiUrlAnaCalendar = "ana_calendar";
const apiUrlLogin = "authLogin/all";
const apiUrlAllUser = "v_auth/allUser";
const apiUrlVacantRequest = "shift/vacant-claim-request";
const actualYear = new Date().getFullYear() + 1;
const maxDate = new Date(actualYear + "-12-31");

function CalXlsPage(props) {
  const useCounterContext = () => useContext(TokenContext);
  let { jwt } = useCounterContext();
  const toastRef = useRef(null);
  const stepperRef = useRef(null);
  const [eventCalendarList, setEventCalendarList] = useState([]);
  const [selectedCaldendarId, setSelectedCalendarId] = useState(null);
  const [calendarSel, setCalendarSel] = useState(null);
  const [shiftSel, setShiftSel] = useState(null);
  const [dayName, setDayName] = useState(null);
  const [availabilitySel, setAvailabilitySel] = useState(null);
  const [availabilityForceSel, setAvailabilityForceSel] = useState(null);
  const [monthlyCheckData, setMonthlycheckData] = useState(null);
  const [defaultDate, setDefaultDate] = useState(() => {
      const state = props.location?.state;
      if (state && state.targetYear !== undefined && state.targetMonth !== undefined) {
        return new Date(state.targetYear, state.targetMonth, 1);
      }
      return new Date();
    });
  const [targetShiftId, setTargetShiftId] = useState(props.location?.state?.targetEventId);
  const [toastObj, setToastObj] = useState(new ToastComponent());
  const [isPublished, setIsPublished] = useState(null);
  const [isEditEnabled, setEditEnabled] = useState(false);
  const [editor, setEditor] = useState(false);
  const [open, setOpen] = useState(false);
  const [openCL, setOpenCL] = useState(false);
  const [openVacantCL,setOpenVacantCL] = useState(false);
  const [showForceDialog, setShowForceDialog] = useState(false);
  const [calData, setCalData] = useState(null);
  const [forceShiftSel, setForceShiftSel] = useState("");
  const [htmlKeyForced, setHtmlKeyForced] = useState("");
  const [forcedAnaUserId, setForcedAnaUserId] = useState(0);
  const [userList, setUserList] = useState(null);
  const [allUserName,setAllUserName] = useState([]);
  // STATO PER IL LAZY MOUNT DEGLI AUTOCOMPLETE
  // Mantiene la chiave htmlKey della sola cella attualmente in fase di editing (es. "0_1_2")
  const [editingCellKey, setEditingCellKey] = useState(null);

  // shift managment
  const [isChangeShiftSidebarVisible, setIsChangeShiftSidebarVisible] = useState(false);
  const [fromUserSel, setFromUserSel] = useState(null);
  const [toUserSel, setToUserSel] = useState(null);
  const [shiftUserSelection, setShiftUserSelection] = useState({});
  const [stepSel, setStepSel] = useState(1);
  const [stepperAdditionalInfo, setStepperAdditionalInfo] = useState(null);
  const [lastUpdate, setLastUpdate] = useState("");
  const [inRequestList, setInRequestList] = useState([]);
  const [outRequestList, setOutRequestList] = useState([]);
  const [isFetchingCompleted, setIsFetchingCompleted] = useState(false);
  const [isShiftChangeConfirmDialogOpen, setIsShiftChangeConfirmDialogOpen] = useState(false);
  const [isChangeShiftRequestConfirmDialogOpen, setIsChangeShiftRequestConfirmDialogOpen] = useState(false);
  const [availabilitySubsetForRequestChange, setAvailabilitySubsetForRequestChange] = useState([]);
  const [isPersonManuallySelected, setIsPersonManuallySelected] = useState(false);
  const [changeShiftRequestData, setChangeShiftRequestData] = useState({});
  const [htmlKeyForChangeShift, setHtmlKeyForChangeShift] = useState("");
  const [toastInfo, setToastInfo] = useState({
    message: "",
    severity: "",
    cssClass: "",
    icon: "",
  });
  const [isMobile, setIsMobile] = useState(window.innerWidth < config.mobileSizeCheck);
  const [expandedDays, setExpandedDays] = useState([]);
  const [allExpanded, setAllExpanded] = useState(false);

  const [openSidePanel, setOpenSidePanel] = useState(false);
  const [lastUpdateAssigment, setLastUpdateAssignement] = useState(Date.now());
  
  // CLAIM VACANT SHIFTS
  const [isVacantSelectMode, setIsVacantSelectMode] = useState(false);
  const [selectedVacantSlot, setSelectedVacantSlot] = useState(null);
  const [openVacantDialog, setOpenVacantDialog] = useState(false);
  const [vacantRequests, setVacantRequests] = useState([]);
  const [openVacantCancelDialog, setOpenVacantCancelDialog] = useState(false);
  const [selectedVacantRequestToCancel, setSelectedVacantRequestToCancel] = useState(null);

  // Funzione helper per mostrare/nascondere il loader
  const [isLoading, setIsLoading] = useState(true);
  const showLoader = () => setIsLoading(true);
  const hideLoader = () => setIsLoading(false);
  
  const isFullAdminOrManager = (userRole, isCalendarManager) => {
    const role = userRole?.toLowerCase() || '';
    return role === 'admin' || role === 'superuser' || isCalendarManager;
  };

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < config.mobileSizeCheck);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (props.location?.state?.targetEventId || props.location?.state?.targetMonth !== undefined) {
      const timer = setTimeout(() => {
        window.history.replaceState({}, document.title);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, []);
  
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (targetShiftId) {
      const timer = setTimeout(() => {
        const element = document.getElementById(`target-desktop-shift-${targetShiftId}`);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          });
        }
      }, 800);

      return () => clearTimeout(timer);
    }
  }, [targetShiftId]);

  const calendarEvents = useMemo(() => {
    // Se non ci sono eventi, ritorna array vuoto
    if (!eventCalendarList || eventCalendarList.length === 0) {
      return [];
    }

    // Mappa ogni evento nel formato standard per CalendarButton
    return eventCalendarList.map(ev => ({
      title: ev.name,
      start: new Date(`${ev.startDate}T${ev.startTime}`),
      end: new Date(`${ev.startDate}T${ev.endTime}`),
      description: ev.description || '',
      location: ''  // Non esiste nei dati originali
    }));
  }, [eventCalendarList]); // ← SI RICALCOLA SOLO SE eventCalendarList CAMBIA

  async function refreshCalendar() {
    setIsLoading(true);
    try 
    {const calendarId = parseInt(
        props.location.pathname.toString().replace("/app/calendarxls/", "")
      );
      setSelectedCalendarId(calendarId);
      const { data: allUser } = await cicassService.getAll(apiUrlLogin);
      setUserList(allUser);
      const { data: anaShift } = await cicassService.getAll(
        apiUrlCalShift + calendarId
      );
      anaShift.sort(function (a, b) {
        return a.viewOrder - b.viewOrder;
      });
      for (let i = 0; i < anaShift.length; i++) {
        anaShift[i].anaUserRoleList.sort(function (x, y) {
          return x.viewOrder - y.viewOrder;
        });
      }
      setShiftSel(anaShift);
      await loadCalendar(
        calendarId,
        calendarSel.year,
        calendarSel.month,
        anaShift,
        allUser
      );

      const calData = (
        await cicassService.getAll(apiUrlAnaCalendar + "/" + calendarId)
      ).data;
      setCalData(calData);
      fetchShiftRequestList(calendarSel.year, calendarSel.month);
      } catch (error) {
        // 🔥 MOSTRA IL MESSAGGIO DAL BACKEND O UNO GENERICO
        const errorMessage = error?.response?.data?.Message || 
                        error?.response?.data?.message || 
                        error?.response?.data ||  // Se il backend torna solo una stringa
                        error?.message ||
                        props.t("Errore nello scaricamento dei dati");
    
        showToast("Error", errorMessage);
    } finally {
      setIsLoading(false);
    }
  }

  async function fetchData() {
    if (dayName === null) {
      showLoader();
      let calendarId = parseInt(
        props.location.pathname.toString().replace("/app/calendarxls/", "")
      );
      setSelectedCalendarId(calendarId);
      let { data: listDay } = await cicassService.getAll(
        apiUrDayCombo + "/" + localStorage.getItem("weblang")
      );
      setDayName(listDay);
      let { data: allUser } = await cicassService.getAll(apiUrlLogin);
      setUserList(allUser);
      let { data: anaShift } = await cicassService.getAll(
        apiUrlCalShift + calendarId
      );
      anaShift.sort(function (a, b) {
        return a.viewOrder - b.viewOrder;
      });
      for (let i = 0; i < anaShift.length; i++) {
        anaShift[i].anaUserRoleList.sort(function (x, y) {
          return x.viewOrder - y.viewOrder;
        });
      }
      setShiftSel(anaShift);
      let { data: allUserListToSee } = await cicassService.getAll(apiUrlAllUser );
      setAllUserName(allUserListToSee); 
      await loadCalendar(
        calendarId,
        defaultDate.getFullYear(),
        defaultDate.getMonth() + 1,
        anaShift,
        allUser
      );
      const myrole = auth.getUserRole();
      let iAmManagerOfCalendar = false;
      if (myrole === "Manager") {
        iAmManagerOfCalendar = (
          await cicassService.getAll(
            apiUrlAnaCalendar + "/ismanager/" + calendarId
          )
        ).data;
      }
      let roleEdit = isFullAdminOrManager(myrole,iAmManagerOfCalendar); 
          
      setEditor(roleEdit);

      let calData = (
        await cicassService.getAll(apiUrlAnaCalendar + "/" + calendarId)
      ).data;
      setCalData(calData);
     
      fetchShiftRequestList( defaultDate.getFullYear(), defaultDate.getMonth() + 1);
      setIsFetchingCompleted(true);
      hideLoader();
    }
  }

  async function fetchShiftRequestList(newYear, newMonth) {
    let year = newYear;
    let month = newMonth;
    if (!newYear && !newMonth) {
      year = calendarSel ? calendarSel.year : defaultDate.getFullYear();
      month = calendarSel ? calendarSel.month : defaultDate.getUTCMonth() + 1;
    }

    let { data: inRequestList } = await cicassService.getAll(apiUrl + "/allrequest/3/" + year + "/" + month);
    let { data: outRequestList } = await cicassService.getAll(apiUrl + "/allrequest/2/" + year + "/" + month);
    setInRequestList(inRequestList);
    setOutRequestList(outRequestList);
    
  }

  const onUserChanged = async (e) => {
    let copyData = calendarSel;
    let idxArray = e.element.id.replace("hk_", "").split("_");

    let forcedBefore =
      calendarSel.days[parseInt(idxArray[0])].shifts[parseInt(idxArray[1])]
        .users[parseInt(idxArray[2])].forced;
    let dataToSave = {
      id: -1,
      shiftId:
        calendarSel.days[parseInt(idxArray[0])].shifts[parseInt(idxArray[1])]
          .shiftId,
      anaCalendarId: calendarSel.anaCalendarId,
      year: calendarSel.year,
      month: calendarSel.month,
      day: calendarSel.days[parseInt(idxArray[0])].day,
      anaShiftId:
        calendarSel.days[parseInt(idxArray[0])].shifts[parseInt(idxArray[1])]
          .anaShiftId,
      shiftUserId:
        calendarSel.days[parseInt(idxArray[0])].shifts[parseInt(idxArray[1])]
          .users[parseInt(idxArray[2])].shiftUserId,
      anaUserId: e.value == null ? 0 : e.value,
      anaUseRoleId:
        calendarSel.days[parseInt(idxArray[0])].shifts[parseInt(idxArray[1])]
          .users[parseInt(idxArray[2])].anaUserRoleId,
      anaShiftStatusId: isPublished,
      forced: e.value == null ? 0 : forcedBefore,
    };

    if (e.value !== null) {
      const mDay = parseInt(idxArray[0]);
      const mShift = parseInt(idxArray[1]);
      const mUser = parseInt(idxArray[2]);
      for (
        let u = 0;
        u < calendarSel.days[mDay].shifts[mShift].users.length;
        u++
      ) {
        let anaUserId =
          calendarSel.days[mDay].shifts[mShift].users[u].anaUserId;
        if (mUser != u) {
          if (anaUserId === (e.value === null ? 0 : e.value)) {
            e.cancel = true;
          }
        }
      }
    }

    let { data: savedData } = await cicassService.saveOp(apiUrl + "/saveshift", dataToSave );
    let prevAnaUserId =
      copyData.days[parseInt(idxArray[0])].shifts[parseInt(idxArray[1])].users[
        parseInt(idxArray[2])
      ].anaUserId;
    copyData.days[parseInt(idxArray[0])].shifts[parseInt(idxArray[1])].shiftId =
      savedData.updatedData.shiftId;
    copyData.days[parseInt(idxArray[0])].shifts[parseInt(idxArray[1])].users[
      parseInt(idxArray[2])
    ].shiftUserId = savedData.updatedData.shiftUserId;
    copyData.days[parseInt(idxArray[0])].shifts[parseInt(idxArray[1])].users[
      parseInt(idxArray[2])
    ].anaUserId = e.value == null ? 0 : e.value;

    if (dataToSave.anaUserId == 0 && forcedBefore == 1) {
      let availability = availabilitySel;
      let toRemove = availability.findIndex(
        (q) =>
          q.day == dataToSave.day &&
          q.anaShiftId == dataToSave.anaShiftId &&
          q.forced == 1 &&
          q.anaUserRoleId == dataToSave.anaUseRoleId &&
          q.anaUserId == prevAnaUserId
      );
      if (toRemove != -1) {
        availability.splice(toRemove, 1);
      }
    }
    setMonthlycheckData(savedData.monthlyCheck);
    setCalendarSel(copyData);
    setLastUpdateAssignement(Date.now());
    
    // Una volta selezionato un valore, disattiviamo l'editing per smontare l'Autocomplete pesante
    setEditingCellKey(null);
  };

  const onMonthChange = async (e) => {
    const year = e.getFullYear();
    const month = e.getMonth() + 1;
    let calIdSel = selectedCaldendarId;
    setDefaultDate(e);
    setCalendarSel(null);
    setMonthlycheckData(null);
    setTargetShiftId(null);
    setIsChangeShiftSidebarVisible(false);
    setEditingCellKey(null);
    
    fetchShiftRequestList(year, month);
    if (e == null) return;
    loadCalendar(calIdSel, year, month, shiftSel, userList);
  };

  const loadCalendar = async (
    calIdSel,
    yearSel,
    monthSel,
    anaShift,
    anaUserList
  ) => {
    showLoader();
    try {
      let calendar = {
        id: 0,
        anaCalendarId: calIdSel,
        year: yearSel,
        month: monthSel,
        daysInMonth: new Date(yearSel, monthSel, 0).getDate(),
        days: [],
      };

      let { data: availability } = await cicassService.getAll(
        apiUrlAvailability +
          calendar.anaCalendarId +
          "," +
          calendar.year +
          "," +
          calendar.month
      );

      let shiftsOfDay = [];
      for (let x = 0; x < anaShift.length; x++) {
        let anaUsers = [];
        for (let y = 0; y < anaShift[x].anaUserRoleList.length; y++) {
          anaUsers.push({
            anaUserRoleId: anaShift[x].anaUserRoleList[y].anaUserRoleId,
            anaUserId: 0,
            shiftUserId: 0,
            forced: 0,
            isSelected: false,
            htmlKey: "-",
          });
        }
        shiftsOfDay.push({
          shiftId: 0,
          anaShiftStatusId: 0,
          anaShiftId: anaShift[x].id,
          users: anaUsers,
        });
      }

      for (let index = 0; index < calendar.daysInMonth; index++) {
        let ana_day_id = new Date(
          calendar.year,
          calendar.month - 1,
          index + 1
        ).getDay();
        calendar.days.push({
          day: index + 1,
          anaDayId: ana_day_id == 0 ? 7 : ana_day_id,
          shifts: JSON.parse(JSON.stringify(shiftsOfDay)),
        });
      }
      let { data: lastUpdateDt } = await cicassService.getAll(
        apiUrlLastUpdate +
          "/" +
          calendar.anaCalendarId +
          "," +
          calendar.year +
          "," +
          calendar.month
      );
      setLastUpdate(lastUpdateDt);
       let { data: xlsResponse } = await cicassService.getAll(
        apiUrlShift +
          "/" +
          calendar.anaCalendarId +
          "," +
          calendar.year +
          "," +
          calendar.month
      );
      let dbData = xlsResponse.shifts || xlsResponse.Shifts || [];
      let claimRequestsData = xlsResponse.claimRequests || xlsResponse.ClaimRequests || [];
      let published = 0;
      let calendarListToAdd = new Array();
      setVacantRequests(claimRequestsData);
      for (let z = 0; z < calendar.days.length; z++) {
        for (let w = 0; w < calendar.days[z].shifts.length; w++) {
          for (let t = 0; t < calendar.days[z].shifts[w].users.length; t++) {
            let dbValue = dbData.filter(
              (q) =>
                q.anaShiftId == calendar.days[z].shifts[w].anaShiftId &&
                (q.anaUserRoleId ==
                  calendar.days[z].shifts[w].users[t].anaUserRoleId ||
                  q.anaUserRoleId == 0) &&
                q.dayFrom == calendar.days[z].day
            );
            calendar.days[z].shifts[w].users[t].htmlKey = z + "_" + w + "_" + t;
            calendar.days[z].shifts[w].users[t].showChangeRequest = false;
            if (dbValue.length == 1) {
              calendar.days[z].shifts[w].users[t].anaUserId =
                dbValue[0].anaUserId;
              calendar.days[z].shifts[w].users[t].shiftUserId = dbValue[0].id;
              calendar.days[z].shifts[w].users[t].forced = dbValue[0].forced;
              calendar.days[z].shifts[w].shiftId = dbValue[0].shiftId;
              calendar.days[z].shifts[w].anaShiftStatusId =
                dbValue[0].anaShiftStatusId;
              if (dbValue[0].anaShiftStatusId === 1) published = 1;
              if (dbValue[0].forced) {
                let volunteer = anaUserList.filter(
                  (q) => q.id == dbValue[0].anaUserId
                );
                if (volunteer == null && dbValue[0].anaUserId != 0)
                  console.log("User", dbValue[0].anaUserId);
                const toForce = {
                  anaDayId: calendar.days[z].anaDayId,
                  anaShiftId: calendar.days[z].shifts[w].anaShiftId,
                  anaUserId: dbValue[0].anaUserId,
                  anaUserRoleId:
                    calendar.days[z].shifts[w].users[t].anaUserRoleId,
                  day: calendar.days[z].day,
                  forced: 1,
                  nameSurname:
                    dbValue[0].anaUserId == 0 ? "" : volunteer[0].name,
                };

                availability.push(toForce);
              }

              if (
                loggedUserId == calendar.days[z].shifts[w].users[t].anaUserId
              ) {
                let shiftToAdd = {
                  name: "Turno 112",
                  description:
                    anaShift
                      .filter((q) => q.id == dbValue[0].anaShiftId)[0]
                      .anaUserRoleList.filter(
                        (w) => w.anaUserRoleId == dbValue[0].anaUserRoleId
                      )[0].roleName +
                    " - " +
                    anaShift.filter((q) => q.id == dbValue[0].anaShiftId)[0]
                      .name,
                  startDate:
                    String(calendar.year) +
                    "-" +
                    (calendar.month < 10 ? "0" : "") +
                    String(calendar.month) +
                    "-" +
                    (calendar.days[z].day < 10 ? "0" : "") +
                    String(calendar.days[z].day),
                  startTime: dbValue[0].shiftFrom.substring(11, 16),
                  endTime: dbValue[0].shiftTo.substring(11, 16),
                };
                calendarListToAdd.push(shiftToAdd);
              }
            }
          }
        }
      }
      setEventCalendarList(calendarListToAdd);
      setAvailabilitySel(availability);
      setIsPublished(published);
      setCalendarSel(calendar);
      setExpandedDays(
        calendar.days.map((day) =>
          day.shifts.some((shift) =>
            shift.users.some((user) => user.anaUserId === loggedUserId)
          )
        )
      );
    } catch (exception) {
      console.error("Error", exception);
    }
    hideLoader();
  };

  // 1. Ricava ID e Nome dell'utente loggato UNA SOLA VOLTA per render/cambio JWT
  const loggedUserId = useMemo(() => auth.getUserId(jwt), [jwt]);
  // Mappa ad accesso rapido O(1) per tutti gli utenti per ID
  const allUserNameMap = useMemo(() => {
    const map = new Map();
    (allUserName || []).forEach((u) => {
      map.set(u.anaUserId, u.nameSurname);
    });
    return map;
  }, [allUserName]);
  const loggedUserName = useMemo(() => {
      if (!loggedUserId || !allUserNameMap) return "";
      return allUserNameMap.get(loggedUserId) || "";
    }, [loggedUserId, allUserNameMap]);

  const subAvailByShiftRole = useMemo(() => {
    const map = new Map();
    for (const item of availabilitySel || []) {
      const key = item.day + "_" + item.anaShiftId + "_" + item.anaUserRoleId;
      if (!map.has(key)) map.set(key, []);
      map.get(key).push(item);
    }
    for (const arr of map.values()) {
      arr.sort((a, b) =>
        a.nameSurname < b.nameSurname ? -1 : a.nameSurname > b.nameSurname ? 1 : 0
      );
    }
    return map;
  }, [availabilitySel]);

  const myEligibleRoleIds = useMemo(() => {
    const currentUser = (allUserName || []).find(u => u.anaUserId === loggedUserId);
    return currentUser?.anaUserRoleIds || [];
  }, [allUserName, jwt, loggedUserId]);

  const myPendingVacantRequests = useMemo(() => {
    return (vacantRequests || []).filter(
      (r) => r.anaUserId === loggedUserId && !r.confirmedAt && !r.refusedAt
    );
  }, [vacantRequests, jwt]);
  


// Set ad accesso rapido O(1) delle disponibilità dell'utente loggato per ID
const loggedUserAvailabilitySet = useMemo(() => {
  const set = new Set();
  (availabilitySel || []).forEach((item) => {
    if (item.anaUserId === loggedUserId) {
      set.add(item.anaUserId);
    }
  });
  return set;
}, [availabilitySel, jwt]);


  function getNumberOfPendingShiftRequests() {
    const incomingPending = inRequestList.filter(
      (request) => !request.confirmedAt && !request.refusedAt
    ).length;
    
    const outgoingPending = outRequestList.filter(
      (request) => !request.confirmedAt && !request.refusedAt
    ).length;
    
    return {
      "out": outgoingPending,
      "in": incomingPending,
      "tot": incomingPending + outgoingPending
    };
  }

  function hasDateExpired() {
    const currentMonth = defaultDate.getUTCMonth() + 1;
    const currentYear = defaultDate.getUTCFullYear();
    return (
      calendarSel.year < currentYear ||
      (calendarSel.year === currentYear && calendarSel.month < currentMonth)
    );
  }

  const printCalendarResponsive = () => {
    if (isPublished !== 1 || !calendarSel || !shiftSel) {
      return (
        <div style={{ padding: "1rem" }}>
          {props.t("calendarSuspend")}
        </div>
      );
    }
    return (
      <div style={{ padding: "1rem" }}>
      <Button
        variant="contained"
        color="primary"
        size="small"
        sx={{ mb: 2 }}
        onClick={toggleAll}
      >
          {!allExpanded ? props.t("collapseAll") : props.t("expandAll")}
        </Button>
        {calendarSel.days.map((day, index) => (
          <ResponsiveCalendarDay
            key={`day_${index}`}
            day={day}
            dayIndex={index}
            targetShiftId={targetShiftId}
            shiftSel={shiftSel}
            dayName={dayName}
            allUserName={allUserName}
            availabilitySel={availabilitySel}
            jwt={jwt}
            t={props.t}
            onClickUser={(day, shiftIdx, userIdx, name) =>
              selectFromOrToUser(false, day, shiftIdx, userIdx, name)
            }
            onClickShiftRequest={(shiftIdx, userIdx, day, user) =>
              changeOnAvailabilityForShift(
                availabilitySel.filter(
                  (a) =>
                    a.day === day &&
                    a.anaShiftId === shiftSel[shiftIdx].id &&
                    a.anaUserRoleId === user.anaUserRoleId
                ),
                shiftIdx,
                userIdx,
                day,
                user.anaUserRoleId // <--- AGGIUNTO
              )
            }
            avoidSelection={new Date(calendarSel.year, calendarSel.month - 1, day.day) < new Date()}
            expanded={expandedDays[index] ?? false}
            onToggleExpand={(dayIdx) => {
              setExpandedDays((prev) =>
                prev.map((val, i) => (i === dayIdx ? !val : val))
              );
            }}
            // --- NUOVE PROPS PER GESTIONE VACANTI ---
            isVacantSelectMode={isVacantSelectMode}
            vacantRequests={vacantRequests}
            onVacantSlotClick={(slotData) => {
              // Gestisci il click su uno slot vacante
              const { day: slotDay, shiftIdx, userIdx } = slotData;
              // Chiama selectFromOrToUser con i dati appropriati
              selectFromOrToUser(false, slotDay, shiftIdx, userIdx, "");
            }}
            onCancelVacantRequest={(day, shiftIdx, userIdx) => {
              handleOpenCancelVacantDialog(day, shiftIdx, userIdx);
            }}
            loggedUserId={loggedUserId}
            myEligibleRoleIds={myEligibleRoleIds}
        />
        ))}
      </div>
    );
  };
  
  const toggleAll = () => {
    const nextExpanded = !allExpanded;
    setExpandedDays(expandedDays.map(() => nextExpanded));
    setAllExpanded(nextExpanded);
  };
  
  const printHeaderDays = () => {
    const day = props.t("day");
    return (
      <Grid
        key={"HEADER_DAY"}
        item
        xs={1}
        style={{ paddingLeft: "2px", paddingRight: "2px" }}
      >
        <Paper className="headerColCalendar hideHeaderDescription">{day}</Paper>
      </Grid>
    );
  };

  const printHeaderRoles = () => {
    return (
      <Grid
        key={"R_Header"}
        item
        xs={1}
        style={{ paddingLeft: "4px", paddingRight: "4px" }}
      >
        <Paper
          className="headerColCalendar hideHeaderDescription"
          style={{ color: "#2c5282" }}
        >
          {props.t("Roles")}
        </Paper>
      </Grid>
    );
  };

  const printHeaderShifts = () => {
    let rows = [];
    let xsValue = (12 / shiftSel.length) >> 0;
    for (let x = 0; x < shiftSel.length; x++) {
      rows.push(
        <Grid
          key={"SHeader_" + x}
          style={{ paddingLeft: "4px", paddingRight: "4px" }}
          item
          xs={xsValue}
        >
          <Paper className="headerColCalendar">
            {shiftSel[x].timeFrom.substring(0, 5) +
              " - " +
              shiftSel[x].timeTo.substring(0, 5)}
          </Paper>
        </Grid>
      );
    }
    return (
      <Grid key={"ShiftHeader"} container item xs={10}>
        {rows}
      </Grid>
    );
  };

  const printDays = (singleDay) => {
    return (
      <Grid key={"D_" + singleDay.day} item xs={1}>
        <Paper className="headerRowDayNr">
          {dayName
            .filter((q) => q.id == singleDay.anaDayId)[0]
            .name.substring(0, 3)}{" "}
          {singleDay.day}
        </Paper>
      </Grid>
    );
  };

  const printRoles = (day) => {
    let rows = [];
    for (let index = 0; index < shiftSel[0].anaUserRoleList.length; index++) {
      rows.push(
        <Grid
          key={
            "R_" + day + "_" + shiftSel[0].anaUserRoleList[index].anaUserRoleId
          }
          item
          xs={12}
        >
          <Paper
            id={`role-label-${index}`}
            className="headerRowRoleDescription"
            style={{ color: "#2c5282" }}
          >
            {shiftSel[0].anaUserRoleList[index].roleName}
          </Paper>
        </Grid>
      );
    }
    return (
      <Grid key={"RH_" + day} item container xs={1}>
        {rows}
      </Grid>
    );
  };

const printShifts = (avoidSelection, singleDay) => {
  let rows = [];
  let xsValue = (12 / singleDay.shifts.length) >> 0;

  for (
    let shiftIndex = 0;
    shiftIndex < singleDay.shifts.length;
    shiftIndex++
  ) {
    let shifts = [];
    for (
      let userIndex = 0;
      userIndex < singleDay.shifts[shiftIndex].users.length;
      userIndex++
    ) {
      const shiftRoleKey =
        singleDay.day + "_" +
        singleDay.shifts[shiftIndex].anaShiftId + "_" +
        singleDay.shifts[shiftIndex].users[userIndex].anaUserRoleId;
      
      let subAvail = subAvailByShiftRole.get(shiftRoleKey) || [];

      const assignedUserId = singleDay.shifts[shiftIndex].users[userIndex].anaUserId;
      if (assignedUserId !== 0) {
        const isAlreadyInAvail = subAvail.some((u) => u.anaUserId === assignedUserId);
        if (!isAlreadyInAvail) {
          // Utilizzo Map anziché .find() su allUserName
          const assignedUserName = allUserNameMap.get(assignedUserId);
          if (assignedUserName) {
            const extraUser = {
              anaUserId: assignedUserId,
              nameSurname: `${assignedUserName} (Assegnato)`,
              anaShiftId: singleDay.shifts[shiftIndex].anaShiftId,
              anaUserRoleId: singleDay.shifts[shiftIndex].users[userIndex].anaUserRoleId,
            };
            subAvail = [extraUser, ...subAvail];
          }
        }
      }

      // Sostituito availabilitySel.filter con il controllo O(1)
      const isLoggedUserAssigned = assignedUserId === loggedUserId;
      const same = assignedUserId === 0 ? false : isLoggedUserAssigned;
      
      // Sostituito allUserName.find con allUserNameMap.get O(1)
      let nameSurnameSelected = "";
      if (assignedUserId !== 0) {
        nameSurnameSelected = allUserNameMap.get(assignedUserId) || "";
      }

      const currentShiftId = singleDay.shifts[shiftIndex].anaShiftId;
      const currentRoleId = singleDay.shifts[shiftIndex].users[userIndex].anaUserRoleId;
      
      const isVacantRequestedByMe = isVacantSelectMode && (vacantRequests || []).some(
        (req) =>
          req.anaUserId === loggedUserId &&
          req.daySel === singleDay.day &&
          req.anaShiftId === currentShiftId &&
          req.anaUserRoleId === currentRoleId &&
          !req.confirmedAt &&
          !req.refusedAt
      );

      const isTargetShift = targetShiftId && String(singleDay.shifts[shiftIndex].shiftId) === String(targetShiftId);

      let backgroundColor = null;
      if (isVacantRequestedByMe) {
        backgroundColor = "#FEF9E7";
      } else if (same) {
        backgroundColor = "#ABEBC6";
      }

      let borderStyle = "2px solid transparent";
      if (isVacantRequestedByMe) {
        borderStyle = "2px solid #F39C12";
      } else if (singleDay.shifts[shiftIndex].users[userIndex].isSelected) {
        borderStyle = "2px solid #006400";
      }
      let displayValue = "";
      if (isVacantRequestedByMe) {
        displayValue = loggedUserName;
      } else if (singleDay.shifts[shiftIndex].users[userIndex].anaUserId !== 0) {
        displayValue = nameSurnameSelected;
      }

      const inputElement = (
        <input
          readOnly={true}
          className="e-input"
          type="text"
          value={displayValue}
          style={{
            fontWeight: same ? "bold" : "normal",
            backgroundColor: backgroundColor,
            border: borderStyle,
            borderRadius:
              singleDay.shifts[shiftIndex].users[userIndex].isSelected || isVacantRequestedByMe
                ? "6px"
                : "0",
            paddingLeft: "4px",
          }}
          onClick={(e) =>
            selectFromOrToUser(
              avoidSelection,
              singleDay.day,
              shiftIndex,
              userIndex,
              nameSurnameSelected
            )
          }
        />
      );

      const cellHtmlKey = singleDay.shifts[shiftIndex].users[userIndex].htmlKey;
      const isCellEditing = editingCellKey === cellHtmlKey;

      shifts.push(
        <Grid
          key={"key_" + cellHtmlKey}
          id={
            isTargetShift
              ? `target-desktop-shift-${targetShiftId}`
              : undefined
          }
          item
          xs={12}
          sx={{
            bgcolor: isTargetShift ? "#f0f7ff" : "transparent",
            borderLeft: isTargetShift ? "4px solid #0078d4" : "4px solid transparent",
            boxShadow: isTargetShift ? "2px 2px 10px rgba(0,0,0,0.05)" : "none",
            transition: "all 0.2s ease-in-out",
            height: "36px", // <--- Fissa l'altezza complessiva dello slot per evitare il CLS
          }}
        >
          {isEditEnabled && (
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center" , width: "100%"}}>
              {isCellEditing ? (
                <div style={{ flexGrow: 1 }}>
                  <ShiftUserSelect
                    id={"hk_" + cellHtmlKey}
                    subAvail={subAvail}
                    currentUserId={singleDay.shifts[shiftIndex].users[userIndex].anaUserId}
                    same={same}
                    currentShiftUsers={singleDay.shifts[shiftIndex].users}
                    userIndex={userIndex}
                    onUserChanged={onUserChanged}
                    autoFocus={true}
                    onBlur={() => setEditingCellKey(null)}
                  />
                </div>
              ) : (
                <div
                  className="cell-readonly-placeholder"
                  onClick={() => setEditingCellKey(cellHtmlKey)}
                  style={{
                    flexGrow: 1,
                    height: "32px",
                    lineHeight: "32px",
                    padding: "0 8px",
                    borderRadius: "4px",
                    cursor: "pointer",
                    backgroundColor: same ? "#ABEBC6" : "#ffffff",
                    fontWeight: same ? "bold" : "normal",
                    fontSize: "0.875rem",
                    border: "1px solid #ccc",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                  }}
                >
                  {nameSurnameSelected || "..."}
                </div>
              )}
              <div style={{ padding: "4px" , flexShrink: 0}}>
                <IconButton
                  size="small"
                  sx={{ marginLeft: 1 }}
                  color="primary"
                  title={props.t("forceShift")}
                  onClick={() => {
                    forceShift(
                      cellHtmlKey
                    );
                  }}
                >
                  <PersonAddIcon fontSize="small" />
                </IconButton>
              </div>
            </div>
          )}
          {!isEditEnabled && (
            <div
              className="e-input-group"
              style={{
                marginBottom: "0px !important",
              }}
            >
              {isVacantRequestedByMe ? (
                <Tooltip title={props.t("Richiesta per turno vacante in attesa di approvazione. Clicca per annullare.")}>
                  <div style={{ display: "flex", width: "100%", alignItems: "center" }}>
                    {inputElement}
                    <IconButton
                      size="small"
                      color="error"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleOpenCancelVacantDialog(singleDay.day, shiftIndex, userIndex);
                      }}
                      sx={{ padding: "2px", marginLeft: "2px" }}
                    >
                      <DeleteOutlineIcon fontSize="small" />
                    </IconButton>
                  </div>
                </Tooltip>
              ) : (
                inputElement
              )}
              {singleDay.shifts[shiftIndex].users[userIndex]
                .showChangeRequest && (
                <IconButton
                  sx={{ marginLeft: 1 }}
                  color="primary"
                  title={props.t("peopleAvailableForShiftRequest")}
                  onClick={() =>
                    changeOnAvailabilityForShift(
                      subAvail,
                      shiftIndex,
                      userIndex,
                      singleDay.day,
                      singleDay.shifts[shiftIndex].users[userIndex].anaUserRoleId
                    )
                  }
                  disabled={isPersonManuallySelected}
                >
                  <PersonAddIcon />
                </IconButton>
              )}
            </div>
          )}
        </Grid>
      );
    }
    rows.push(
      <Grid
        key={"S" + singleDay.day + "_" + shiftIndex}
        style={{ paddingLeft: "5px", paddingRight: "5px" }}
        item
        xs={xsValue}
      >
        {shifts}
      </Grid>
    );
  }
  return (
    <Grid key={"SH_" + singleDay.day} container item xs={10}>
      {rows}
    </Grid>
  );
};

  const forceActualShift = async () => {
    let copyData = calendarSel;
    let idxArray = htmlKeyForced.replace("hk_", "").split("_");
    let forced = forcedAnaUserId == 0 ? 0 : 1;
    let dataToSave = {
      id: -1,
      shiftId:
        calendarSel.days[parseInt(idxArray[0])].shifts[parseInt(idxArray[1])]
          .shiftId,
      anaCalendarId: calendarSel.anaCalendarId,
      year: calendarSel.year,
      month: calendarSel.month,
      day: calendarSel.days[parseInt(idxArray[0])].day,
      anaShiftId:
        calendarSel.days[parseInt(idxArray[0])].shifts[parseInt(idxArray[1])]
          .anaShiftId,
      shiftUserId:
        calendarSel.days[parseInt(idxArray[0])].shifts[parseInt(idxArray[1])]
          .users[parseInt(idxArray[2])].shiftUserId,
      anaUserId: forcedAnaUserId,
      anaUseRoleId:
        calendarSel.days[parseInt(idxArray[0])].shifts[parseInt(idxArray[1])]
          .users[parseInt(idxArray[2])].anaUserRoleId,
      anaShiftStatusId: isPublished,
      forced: forced,
    };

    if (forced == 1) {
      const myArray = htmlKeyForced.split("_");
      const mDay = parseInt(myArray[0]);
      const mShift = parseInt(myArray[1]);
      const mUser = parseInt(myArray[2]);
      for (
        let u = 0;
        u < calendarSel.days[mDay].shifts[mShift].users.length;
        u++
      ) {
        let anaUserId =
          calendarSel.days[mDay].shifts[mShift].users[u].anaUserId;
        if (mUser != u) {
          if (anaUserId == forcedAnaUserId) {
            return;
          }
        }
      }
    }

    let { data: savedData } = await cicassService.saveOp(apiUrl + "/saveshift", dataToSave);
    copyData.days[parseInt(idxArray[0])].shifts[parseInt(idxArray[1])].shiftId =
      savedData.updatedData.shiftId;
    copyData.days[parseInt(idxArray[0])].shifts[parseInt(idxArray[1])].users[
      parseInt(idxArray[2])
    ].shiftUserId = savedData.updatedData.shiftUserId;
    copyData.days[parseInt(idxArray[0])].shifts[parseInt(idxArray[1])].users[
      parseInt(idxArray[2])
    ].forced = forced;
    copyData.days[parseInt(idxArray[0])].shifts[parseInt(idxArray[1])].users[
      parseInt(idxArray[2])
    ].anaUserId = forcedAnaUserId;
    setMonthlycheckData(savedData.monthlyCheck);
    setCalendarSel(copyData);
    if (forced == 1) {
      let filterSel = availabilityForceSel.filter(
        (q) => q.anaUserId == forcedAnaUserId
      );
      filterSel[0].forced = 1;
      availabilitySel.push(filterSel[0]);
    }
    setLastUpdateAssignement(Date.now());
    setShowForceDialog(false);
  };

  const changeOnAvailabilityForShift = (
    shiftAvailability,
    shiftIndex,
    userIndex,
    day,
    requiredRoleId
  ) => {
    // 1. Recupera tutti gli utenti che hanno il ruolo richiesto
    const allUsersWithRole = (allUserName || []).filter((u) =>
      (u.anaUserRoleIds || []).includes(requiredRoleId)
    );

    // 2. Unisci i dati: disponibilità + tutti gli altri
    const unifiedData = allUsersWithRole.map((u) => {
      const availability = shiftAvailability.find(
        (a) => a.anaUserId === u.anaUserId
      );
      return {
        anaUserId: u.anaUserId,
        nameSurname: u.nameSurname,
        anaUserRoleId: requiredRoleId,
        isAvailable: !!availability, // Flag verde/grigio
        day: day,
      };
    });

    // 3. Ordina: prima i disponibili, poi in ordine alfabetico
    unifiedData.sort((a, b) => {
      if (a.isAvailable && !b.isAvailable) return -1;
      if (!a.isAvailable && b.isAvailable) return 1;
      return a.nameSurname.localeCompare(b.nameSurname);
    });

    // 4. Escludi l'utente loggato e chi è già assegnato a quel turno
    const alreadyAssignedUserIds =
      calendarSel?.days?.[day - 1]?.shifts?.[shiftIndex]?.users
        ?.map((u) => u.anaUserId)
        .filter((id) => id !== 0) || [];

    const finalData = unifiedData.filter(
      (item) =>
        item.anaUserId !== loggedUserId &&
        !alreadyAssignedUserIds.includes(item.anaUserId)
    );

    // 5. Passa i dati alla Dialog
    setAvailabilitySubsetForRequestChange({
      dataSource: finalData,
      shiftIndex,
      userIndex,
    });
    setIsChangeShiftRequestConfirmDialogOpen(true);
  };

  const forceShift = async (htmlKey) => {
    const myArray = htmlKey.split("_");
    const mDay = parseInt(myArray[0]);
    const mShift = parseInt(myArray[1]);
    const mUser = parseInt(myArray[2]);
    let subShift = shiftSel.filter(
      (q) => q.id == calendarSel.days[mDay].shifts[mShift].anaShiftId
    )[0];
    let subRole = shiftSel[0].anaUserRoleList.filter(
      (q) =>
        q.anaUserRoleId ==
        calendarSel.days[mDay].shifts[mShift].users[mUser].anaUserRoleId
    )[0];
    let mSelection =
      dayName
        .filter((q) => q.id == calendarSel.days[mDay].anaDayId)[0]
        .name.substring(0, 3) +
      " " +
      calendarSel.days[mDay].day;
    mSelection =
      mSelection +
      " - " +
      subShift.name +
      " " +
      subShift.timeFrom.substring(0, 5) +
      " - " +
      subShift.timeTo.substring(0, 5);
    mSelection = mSelection + " - " + subRole.roleName;
    setForceShiftSel(mSelection);
    setShowForceDialog(true);
    let url =
      apiUrlAvailability +
      "force/" +
      calendarSel.anaCalendarId +
      "," +
      calendarSel.days[mDay].shifts[mShift].anaShiftId +
      "," +
      calendarSel.days[mDay].shifts[mShift].users[mUser].anaUserRoleId +
      "," +
      calendarSel.year +
      "," +
      calendarSel.month +
      "," +
      calendarSel.days[mDay].day +
      "," +
      calendarSel.days[mDay].anaDayId;
    let { data: availability } = await cicassService.getAll(url);
    availability.sort(function (a, b) {
      if (a.nameSurname < b.nameSurname) {
        return -1;
      }
      if (a.nameSurname > b.nameSurname) {
        return 1;
      }
      return 0;
    });

    setHtmlKeyForced(htmlKey);
    setAvailabilityForceSel(availability);
  };

  const onUserForcedOpen = (e) => {
    let idx = 0;
    let idxArray = htmlKeyForced.split("_");
    let myComboList = e.popup.element.querySelectorAll(".e-list-item");
    myComboList.forEach((element) => {
      e.popup.element
        .querySelectorAll(".e-list-item")
        [idx].classList.remove("e-disabled");
      e.popup.element
        .querySelectorAll(".e-list-item")
        [idx].classList.remove("e-overlay");
      for (
        let x = 0;
        x <
        calendarSel.days[parseInt(idxArray[0])].shifts[parseInt(idxArray[1])]
          .users.length;
        x++
      ) {
        if (x != parseInt(idxArray[2])) {
          if (
            calendarSel.days[parseInt(idxArray[0])].shifts[
              parseInt(idxArray[1])
            ].users[x].anaUserId == Number(element.dataset.value)
          ) {
            e.popup.element
              .querySelectorAll(".e-list-item")
              [idx].classList.add("e-disabled");
            e.popup.element
              .querySelectorAll(".e-list-item")
              [idx].classList.add("e-overlay");
          }
        }
      }
      idx = idx + 1;
    });
  };

  const onForcedUserChanged = (e) => {
    setForcedAnaUserId(e.value == null ? 0 : e.value);
  };

  const printCalendar = () => {
    let rows = [];
    if (!isEditEnabled && !isPublished) {
      return (
        <div id="CalSuspend" className="calendarXlsContent">{props.t("calendarSuspend")}</div>
      );
    }

    const FirstLine = ({ index }) => {
      const className = index === null ? "sticky headerLine" : "firstLine";
      return (
        <Grid key={`cal_header_${index}`} container className={className}>
          {printHeaderDays()}
          {printHeaderRoles()}
          {printHeaderShifts()}
        </Grid>
      );
    };

    let today = new Date();
    let avoidSelectionForChange = true;
    rows.push(<FirstLine index={null} />);
    for (let index = 0; index < calendarSel.daysInMonth; index++) {
      if (
        today.getTime() >
        new Date(calendarSel.year, calendarSel.month - 1, index + 1).getTime()
      )
        avoidSelectionForChange = true;
      else avoidSelectionForChange = false;
      rows.push(
        <Grid
          key={"cal_" + index}
          container
          className={index % 2 == 0 ? "roundWhite" : "roundGray"}
        >
          <FirstLine index={index} />
          {printDays(calendarSel.days[index])}
          {printRoles(index + 1)}
          {printShifts(avoidSelectionForChange, calendarSel.days[index])}
        </Grid>
      );
    }
    return (
      <Box sx={{ display: 'flex', width: '100%', position: 'relative' }}>
        <Box 
          id="CalXls"
          sx={{ 
            flex: 1,
            minWidth: 0,
            transition: 'all 0.3s ease', 
            marginRight: openSidePanel ? '0px' : 0,
          }}
        >
          <div id="CalAvailable" className="calendarXlsContent">{rows}</div>
        </Box>

        <AssignmentsSidePanel
          open={openSidePanel && isEditEnabled}
          onClose={() => setOpenSidePanel(false)}
          calendarId={calendarSel.anaCalendarId}
          year={calendarSel.year}
          month={calendarSel.month}
          apiUrl={apiUrl}
          t={props.t}
          lastUpdate={lastUpdateAssigment}
        />
      </Box>
    );
  };

  const changeShiftStatus = async (statusId) => {
    let { data: scheduleData } = await cicassService.getAll(
      apiUrl +
        "/changestatus/" +
        calendarSel.anaCalendarId +
        "," +
        calendarSel.year +
        "," +
        calendarSel.month +
        "," +
        statusId
    );
    let msgTitle = props.t("calendarPublication");
    let msgContent =
      statusId == 0 ? props.t("calendarPubS1") : props.t("calendarPubA1");
    showToastInfo(
      statusId,
      statusId == 0 ? "Warning" : "Information",
      msgTitle,
      msgContent
    );
  };

  const handleShiftRequestsDialogClick = async (args) => {
  if (args.rowData.confirmedAt !== null || args.rowData.refusedAt !== null || hasDateExpired())
    return;

  setChangeShiftRequestData({
    requestType: args.commandColumn.type,
    id: args.rowData.id,
    rowData: args.rowData  // ← NUOVO: salva i dettagli
  });

  setIsShiftChangeConfirmDialogOpen(true);
};

  const handleVacantShiftAdminAction = async (e) => {
    const { commandColumn, rowData } = e;
    if (!rowData || !rowData.id) return;

    try {
      let response;
      if (commandColumn.type === "confirm") {
        response = await cicassService.getAll(`${apiUrlVacantRequest}/${rowData.id}/confirm`);
      } else if (commandColumn.type === "refuse" ) {
        response = await cicassService.getAll(`${apiUrlVacantRequest}/${rowData.id}/refuse`);
      }
      else{
        showToast("Warning", props.t("Operazione non corretta"));
        return;
      }
      await refreshCalendar();
      eventBus.emit("refreshCounts");
      const backendMessage = response?.data?.Message || response?.data?.message || props.t("Operazione completata con successo");
      showToast("Success", backendMessage);
      
    } catch (error) {
      // 🔥 MOSTRA IL MESSAGGIO DAL BACKEND O UNO GENERICO
      const errorMessage = error?.response?.data?.Message || 
                        error?.response?.data?.message || 
                        error?.response?.data ||  // Se il backend torna solo una stringa
                        error?.message ||
                        props.t("Errore durante la gestione della richiesta turno vacant");
    
      showToast("Error", errorMessage);

    }
  };

  const handleOpenCancelVacantDialog = (day, shiftIndex, userIndex) => {
    const currentShiftId = calendarSel.days[day - 1].shifts[shiftIndex].anaShiftId;
    const currentRoleId = calendarSel.days[day - 1].shifts[shiftIndex].users[userIndex].anaUserRoleId;

    const reqToCancel = (vacantRequests || []).find(
      (req) =>
        req.anaUserId === loggedUserId &&
        req.daySel === day &&
        req.anaShiftId === currentShiftId &&
        req.anaUserRoleId === currentRoleId &&
        !req.confirmedAt &&
        !req.refusedAt
    );

    if (reqToCancel) {
      setSelectedVacantRequestToCancel(reqToCancel);
      setOpenVacantCancelDialog(true);
    }
  };

  const handleToggleVacantMode = () => {
    if (isChangeShiftSidebarVisible) {
      stepperFullReset();
    }
    if (editor) {
      setOpenVacantCL(true);
    } else {
      setIsVacantSelectMode((prev) => !prev);
    }
  };

  const handleConfirmVacantApplication = async () => {
    if (!selectedVacantSlot) return;

    try {
      const payload = selectedVacantSlot;
      const response = await cicassService.saveOp(apiUrlVacantRequest, payload);
      await refreshCalendar();
      const backendMessage = response?.data?.Message || response?.data?.message || props.t("Candidatura inviata con successo");
      showToast("Success", backendMessage);
      eventBus.emit("refreshCounts");
      setOpenVacantDialog(false);
      setSelectedVacantSlot(null);
      
    } catch (error) {
      // 🔥 MOSTRA IL MESSAGGIO DAL BACKEND O UNO GENERICO
    const errorMessage = error?.response?.data?.Message || 
                        error?.response?.data?.message || 
                        error?.response?.data ||  // Se il backend torna solo una stringa
                        error?.message ||
                        props.t("Errore durante l'invio della candidatura");
    
    showToast("Error", errorMessage);
    }
  };

  const handleConfirmCancelVacantRequest = async () => {
    if (!selectedVacantRequestToCancel) return;

    try {
      const response = await cicassService.deleteOp(apiUrlVacantRequest, selectedVacantRequestToCancel.id);
      const backendMessage = response?.data?.Message || response?.data?.message || props.t("Candidatura annullata");
      await refreshCalendar();
      showToast("Success", backendMessage);
      eventBus.emit("refreshCounts");
      setOpenVacantCancelDialog(false);
      setSelectedVacantRequestToCancel(null);
      
    } catch (error) {
      // 🔥 MOSTRA IL MESSAGGIO DAL BACKEND O UNO GENERICO
    const errorMessage = error?.response?.data?.Message || 
                        error?.response?.data?.message || 
                        error?.response?.data ||  // Se il backend torna solo una stringa
                        error?.message ||
                        props.t("Errore durante la cancellazione della candidatura");
    
    showToast("Error", errorMessage);
    }
  };

  async function handleChangeShiftRequest() {
    let apiUrlCmd;
    let toastMessage = "-";
    let toastSeverity = "Success";
    const requestTypeOriginal = changeShiftRequestData.requestType;
    switch (requestTypeOriginal) {
      case "Delete":
        apiUrlCmd = {
          endpoint: "shift/removerequest",
          method: "deleteOp",
        };
        toastMessage = props.t("toastShiftRequestDeletedSuccess");
        break;
      case "Yes":
        apiUrlCmd = {
          endpoint: "shift/confirmrequest",
          method: "getById",
        };
        toastMessage = props.t("toastShiftRequestAcceptedSuccess");
        break;
      case "No":
        apiUrlCmd = {
          endpoint: "shift/refuserequest",
          method: "getById",
        };
        toastMessage = props.t("toastShiftRequestDeniedSuccess");
        break;
      default:
        return;
    }

    const response = await cicassService[apiUrlCmd.method](
      apiUrlCmd.endpoint,
      changeShiftRequestData.id
    );
    if (response.status !== 200) {
      toastSeverity = "Error";
      toastMessage = props.t("toastShiftRequestFailureMessage");
    }
    if (requestTypeOriginal === "Yes") {
      await refreshCalendar();
    }
    else
    {
      await fetchShiftRequestList(calendarSel.year, calendarSel.month);
    }
    eventBus.emit("refreshCounts");  
    setChangeShiftRequestData({});
    setIsShiftChangeConfirmDialogOpen(false);
    return { severity: toastSeverity, message: toastMessage };
  }

  function senderRowDataBound(args) {
    if (
      args.data.confirmedAt !== null ||
      args.data.refusedAt !== null ||
      hasDateExpired()
    ) {
      args.row
        .querySelectorAll(".e-icons.e-delete")[0]
        .classList.add("e-disabled");
      args.row.querySelectorAll(".e-deletebutton")[0].style.cursor = "auto";
    }
  }

  function recieverRowDataBound(args) {
    if (
      args.data.confirmedAt !== null ||
      args.data.refusedAt !== null ||
      hasDateExpired()
    ) {
      args.row
        .querySelectorAll(".e-icons.e-check-mark-01")[0]
        .classList.add("e-disabled");
      args.row.querySelectorAll(".e-check-mark-01")[0].style.cursor = "auto";

      args.row
        .querySelectorAll(".e-icons.e-close")[0]
        .classList.add("e-disabled");
      args.row.querySelectorAll(".e-close")[0].style.cursor = "auto";
    }
  }

  const showToastInfo = (newShiftStatusId, type, title, content) => {
    let copyData = calendarSel;
    toastObj.hide();
    switch (type) {
      case "Warning":
        toastObj.title = title;
        toastObj.content = content;
        toastObj.cssClass = "e-toast-warning";
        toastObj.icon = "e-warning toast-icons";
        break;
      case "Success":
        toastObj.title = title;
        toastObj.content = content;
        toastObj.cssClass = "e-toast-success";
        toastObj.icon = "e-success toast-icons";
        break;
      case "Error":
        toastObj.title = title;
        toastObj.content = content;
        toastObj.cssClass = "e-toast-danger";
        toastObj.icon = "e-error toast-icons";
        break;
      case "Information":
        toastObj.title = title;
        toastObj.content = content;
        toastObj.cssClass = "e-toast-info";
        toastObj.icon = "e-info toast-icons";
        break;
      default:
        break;
    }

    for (let d = 0; d < copyData.days.length; d++) {
      for (let s = 0; s < copyData.days[d].shifts[s].length; s++) {
        copyData.days[d].shifts[s].anaShiftStatusId = newShiftStatusId;
      }
    }
    setCalendarSel(copyData);
    setIsPublished(newShiftStatusId);
    toastObj.show();
    return;
  };

  function showToast(title, errorMsg) {
    toastObj.hide();
    switch (title) {
      case "Warning":
        toastObj.title = "Warning";
        toastObj.content = errorMsg;
        toastObj.cssClass = "e-toast-warning";
        toastObj.icon = "e-warning toast-icons";
        break;
      case "Success":
        toastObj.title = "Success";
        toastObj.content = errorMsg;
        toastObj.cssClass = "e-toast-success";
        toastObj.icon = "e-success toast-icons";
        break;
      case "Error":
        toastObj.title = "Error";
        toastObj.content = errorMsg;
        toastObj.cssClass = "e-toast-danger";
        toastObj.icon = "e-error toast-icons";
        break;
      case "Information":
        toastObj.title = "Information";
        toastObj.content = errorMsg;
        toastObj.cssClass = "e-toast-info";
        toastObj.icon = "e-info toast-icons";
        break;
      default:
        break;
    }
    toastObj.show();
  }

  const printOnFile = async () => {
    showLoader();
    let roleList = shiftSel[0].anaUserRoleList;
    let calandarString = [];
    let preHead = [];
    preHead.push("");
    preHead.push("");
    const today = new Date(calendarSel.year, calendarSel.month - 1, 1);
    const lang = localStorage.getItem("weblang").toLowerCase();
    preHead.push(
      today
        .toLocaleString(lang + "-" + lang.toUpperCase(), { month: "long" })
        .toUpperCase()
    );
    preHead.push(calendarSel.year.toString());
    for (let y = 0; y < shiftSel.length - 2; y++) {
      preHead.push("");
    }
    calandarString.push(preHead);
    let head = [];
    head.push(props.t("day"));
    head.push(props.t("Roles"));
    for (let x = 0; x < shiftSel.length; x++) {
      head.push(
        shiftSel[x].timeFrom.substring(0, 5) +
          " - " +
          shiftSel[x].timeTo.substring(0, 5)
      );
    }
    calandarString.push(head);
    for (let d = 0; d < calendarSel.days.length; d++) {
      let subSet = availabilitySel.filter(
        (q) => q.day == calendarSel.days[d].day
      );
      for (let index = 0; index < roleList.length; index++) {
        let row = [];
        if (index == 0)
          row.push(
            dayName
              .filter((q) => q.id == calendarSel.days[d].anaDayId)[0]
              .name.substring(0, 3) +
              " " +
              calendarSel.days[d].day
          );
        else row.push("");
        row.push(roleList[index].roleName);
        for (let sh = 0; sh < calendarSel.days[d].shifts.length; sh++) {
          let userName = "";
          if (calendarSel.days[d].shifts[sh].users[index].anaUserId != 0)
            userName = subSet.filter(
              (q) =>
                q.anaUserId ==
                calendarSel.days[d].shifts[sh].users[index].anaUserId
            )[0].nameSurname;
          row.push(userName);
        }
        calandarString.push(row);
      }
    }
    let sendData = { id: -1, allRows: calandarString };
    await cicassService.downloadFilePost(
      apiUrl + "/download/" + calendarSel.anaCalendarId,
      sendData,
      "XLSX"
    );
    hideLoader();
  };

  const resetChangeShift = () => {
    if (fromUserSel != null) {
      calendarSel.days[fromUserSel.day - 1].shifts[fromUserSel.shift].users[
        fromUserSel.user
      ].isSelected = false;
      setFromUserSel(null);
    }
    if (toUserSel != null) {
      calendarSel.days[toUserSel.day - 1].shifts[toUserSel.shift].users[
        toUserSel.user
      ].isSelected = false;
      setToUserSel(null);
    }
    setStepSel(1);
  };

  const changeShiftWithOtherUser = async () => {
    const nextSidebarState = !isChangeShiftSidebarVisible;
    if (nextSidebarState) {
      setIsVacantSelectMode(false);
    }

    setIsChangeShiftSidebarVisible(nextSidebarState);
    toggleChangeShiftIcon(false);
    resetChangeShift();
  };

  const selectFromOrToUser = (
    skipSelectionForChange,
    day,
    shiftIdx,
    userIdy,
    nameSurname
  ) => {
    if (isVacantSelectMode){

      const currentShiftId = calendarSel?.days?.[day - 1]?.shifts?.[shiftIdx]?.anaShiftId;
      const targetUserSlot = calendarSel?.days?.[day - 1]?.shifts?.[shiftIdx]?.users?.[userIdy];
      const hasPendingRequest = (vacantRequests || []).some(
        (req) =>
          req.anaUserId === loggedUserId &&
          req.daySel === day &&
          req.anaShiftId === currentShiftId &&
          //req.anaUserRoleId === targetUserSlot?.anaUserRoleId &&
          !req.confirmedAt &&
          !req.refusedAt
      );

      if (hasPendingRequest) {
        showToast("Warning", props.t("Hai già una richiesta pendente per questo turno"));
        return;
      }

      let today = new Date();
      today.setHours(0, 0, 0, 0);
      let slotDate = new Date(calendarSel.year,calendarSel.month - 1, day); 
      slotDate.setHours(0,0,0);
      if (slotDate < today) {
        showToast("Warning", props.t("Seleziona una data maggiore o uguale a oggi") );
        return;
      }
      
      if (!targetUserSlot) return;

      if (targetUserSlot.anaUserId !== 0) {
        showToast("Warning", props.t("Il turno selezionato è già pianificato"));
        return;
      }
    
      const isRoleQualified = myEligibleRoleIds?.includes(targetUserSlot.anaUserRoleId);

      if (!isRoleQualified) {
        showToast("Warning", props.t("Non possiedi la qualifica necessaria per questo ruolo") );
        return;
      }
let roleName = "";
    const allRoles = shiftSel[0]?.anaUserRoleList || [];
    const foundRole = allRoles.find(r => r.anaUserRoleId === targetUserSlot.anaUserRoleId);
    if (foundRole) {
      roleName = foundRole.roleName;
    }

      const shiftInfo = shiftSel.find((s) => s.id === calendarSel?.days?.[day - 1]?.shifts?.[shiftIdx]?.anaShiftId);
      const shiftTimeText = shiftInfo
        ? shiftInfo.name + " " + shiftInfo.timeFrom + " - " + shiftInfo.timeTo
        : "-";
      setSelectedVacantSlot({
        anaCalendarId: calendarSel.anaCalendarId,
        anaShiftId: calendarSel?.days?.[day - 1]?.shifts?.[shiftIdx]?.anaShiftId,
        anaUserRoleId: targetUserSlot.anaUserRoleId,
        anaUserId: loggedUserId, 
        yearSel: calendarSel.year,
        monthSel: calendarSel.month,
        daySel : day,
        notes : "Richiesta Web",
        roleName: roleName,
        shiftDescription: shiftTimeText, 
        id: -1
      });

      setOpenVacantDialog(true);
      return;
    }

    if (skipSelectionForChange) return;
    if (!isChangeShiftSidebarVisible) return;
    if (stepSel === 1) {
      if (
        loggedUserId !=
        calendarSel.days[day - 1].shifts[shiftIdx].users[userIdy].anaUserId
      )
        return;
      if (fromUserSel != null) {
        calendarSel.days[fromUserSel.day - 1].shifts[fromUserSel.shift].users[
          fromUserSel.user
        ].isSelected = false;
        if (
          day == fromUserSel.day &&
          shiftIdx == fromUserSel.shift &&
          userIdy == fromUserSel.user
        ) {
          setFromUserSel(null);
          setHtmlKeyForChangeShift("");
          return;
        }
      }

      calendarSel.days[day - 1].shifts[shiftIdx].users[
        userIdy
      ].isSelected = true;
      let mySel = {
        nameSurname: nameSurname,
        shiftUserId:
          calendarSel.days[day - 1].shifts[shiftIdx].users[userIdy].shiftUserId,
        anaUserId:
          calendarSel.days[day - 1].shifts[shiftIdx].users[userIdy].anaUserId,
        anaUserRoleId:
          calendarSel.days[day - 1].shifts[shiftIdx].users[userIdy]
            .anaUserRoleId,
        day: day,
        shift: shiftIdx,
        user: userIdy,
      };
      setFromUserSel(mySel);
      setHtmlKeyForChangeShift(
        "hk_" + (day - 1) + "_" + shiftIdx + "_" + userIdy
      );
      setCalendarSel(calendarSel);
    }
    if (stepSel === 2) {
     
      const targetUser = calendarSel.days[day - 1].shifts[shiftIdx].users[userIdy];
       /* VECCHIO CODICE PARITA' DI RUOLO
      if (
        !targetUser.anaUserId || 
        targetUser.anaUserId === 0 ||
        loggedUserId == targetUser.anaUserId ||
        userIdy != fromUserSel.user
      ) {
        return;
      }*/
      // 🔒 BLOCCA STESSO TURNO
      if (fromUserSel.shift === shiftIdx && fromUserSel.day === day) {
        showToast("Warning", "Non puoi scambiare lo stesso turnoo");
        return;
      }
      // ✅ NUOVO CONTROLLO RUOLO (include)
      debugger;
      const fromUserRoles = allUserName.find(u => u.anaUserId === fromUserSel.anaUserId)?.anaUserRoleIds || [];
      const toUserRoles = allUserName.find(u => u.anaUserId === targetUser.anaUserId)?.anaUserRoleIds || [];

      const fromCanDoToRole = fromUserRoles.includes(targetUser.anaUserRoleId);
      const toCanDoFromRole = toUserRoles.includes(fromUserSel.anaUserRoleId);

      if (!fromCanDoToRole || !toCanDoFromRole) {
        showToast("Warning", props.t("Il cambio turno è consentito solo se entrambi gli utenti hanno i ruoli necessari per il turno che riceveranno"));
        return;
      }
      // FINE MIGLIORIA
      /*if (loggedUserId ==  calendarSel.days[day - 1].shifts[shiftIdx].users[userIdy].anaUserId || userIdy != fromUserSel.user  ) {
        return;
      }*/

      if (toUserSel !== null) {
        calendarSel.days[toUserSel.day - 1].shifts[toUserSel.shift].users[
          toUserSel.user
        ].isSelected = false;

        if (
          day === toUserSel.day &&
          shiftIdx === toUserSel.shift &&
          userIdy === toUserSel.user
        ) {
          setToUserSel(null);
          setIsPersonManuallySelected(false);
          return;
        }
      }
      calendarSel.days[day - 1].shifts[shiftIdx].users[
        userIdy
      ].isSelected = true;

      let mySel = {
        nameSurname: nameSurname,
        shiftUserId:
          calendarSel.days[day - 1].shifts[shiftIdx].users[userIdy].shiftUserId,
        anaUserId:
          calendarSel.days[day - 1].shifts[shiftIdx].users[userIdy].anaUserId,
        anaUserRoleId:
          calendarSel.days[day - 1].shifts[shiftIdx].users[userIdy]
            .anaUserRoleId,
        day: day,
        shift: shiftIdx,
        user: userIdy,
      };
      setIsPersonManuallySelected(true);
      setToUserSel(mySel);
      setCalendarSel(calendarSel);
    }
  };

  const saveChangeShiftRequest = async () => {
    let roleList = shiftSel[0].anaUserRoleList;

    let FromDescr =
      dayName
        .filter(
          (q) => q.id == calendarSel.days[fromUserSel.day - 1].anaDayId
        )[0]
        .name.substring(0, 3) +
      " " +
      fromUserSel.day;
    FromDescr =
      FromDescr +
      " " +
      (shiftSel[fromUserSel.shift].timeFrom.hours < 10 ? "0" : "") +
      shiftSel[fromUserSel.shift].timeFrom.hours +
      ":" +
      (shiftSel[fromUserSel.shift].timeFrom.minutes < 10 ? "0" : "") +
      shiftSel[fromUserSel.shift].timeFrom.minutes +
      " - " +
      (shiftSel[fromUserSel.shift].timeTo.hours < 10 ? "0" : "") +
      shiftSel[fromUserSel.shift].timeTo.hours +
      ":" +
      (shiftSel[fromUserSel.shift].timeTo.minutes < 10 ? "0" : "") +
      shiftSel[fromUserSel.shift].timeTo.minutes;
    FromDescr =
      FromDescr +
      " " +
      roleList.filter(function (q) {
        return q.anaUserRoleId == fromUserSel.anaUserRoleId;
      })[0].roleName;

    let ToDescr =
      dayName
        .filter((q) => q.id == calendarSel.days[toUserSel.day - 1].anaDayId)[0]
        .name.substring(0, 3) +
      " " +
      toUserSel.day;
    ToDescr =
      ToDescr +
      " " +
      (shiftSel[toUserSel.shift].timeFrom.hours < 10 ? "0" : "") +
      shiftSel[toUserSel.shift].timeFrom.hours +
      ":" +
      (shiftSel[toUserSel.shift].timeFrom.minutes < 10 ? "0" : "") +
      shiftSel[toUserSel.shift].timeFrom.minutes +
      " - " +
      (shiftSel[toUserSel.shift].timeTo.hours < 10 ? "0" : "") +
      shiftSel[toUserSel.shift].timeTo.hours +
      ":" +
      (shiftSel[toUserSel.shift].timeTo.minutes < 10 ? "0" : "") +
      shiftSel[toUserSel.shift].timeTo.minutes;
    ToDescr =
      ToDescr +
      " " +
      roleList.filter((q) => q.anaUserRoleId == toUserSel.anaUserRoleId)[0]
        .roleName;

    let dataToSave = {
      id: -1,
      fromShiftUserId: fromUserSel.shiftUserId,
      fromAnaUserId: fromUserSel.anaUserId,
      toShiftUserId: toUserSel.shiftUserId,
      toAnaUserId: toUserSel.anaUserId,
      requestTypeId: fromUserSel.shiftUserId === toUserSel.shiftUserId ? 2 : 1,
      ResponseTypeId: 0,
      CreatedAt: new Date(),
      fromDescription: FromDescr + " " + fromUserSel.nameSurname,
      toDescription: ToDescr + " " + toUserSel.nameSurname,
      yearSel: calendarSel.year,
      monthSel: calendarSel.month,
    };
    await cicassService.saveOp(apiUrl + "/changerequest", dataToSave);

    toastObj.title = props.t("calendarChangeShiftTitle");
    toastObj.content = props.t("calendarChangeShiftContent");
    toastObj.cssClass = "e-toast-info";
    toastObj.icon = "e-info toast-icons";
    toastObj.show();
    setIsPersonManuallySelected(false);
    fetchShiftRequestList(calendarSel.year, calendarSel.month);
    return true;
  };

  const stepperFullReset = () => {
      resetChangeShift();
      setIsPersonManuallySelected(false);
      toggleChangeShiftIcon(false);
      setIsChangeShiftSidebarVisible(false);
      stepperRef?.current?.reset();
  };

  const stepperPartialReset = () => {
      setToUserSel(null);
      setIsPersonManuallySelected(false);
  };

  function handleShiftChangeDropdown(event) {
    if (!event) return;
    const { itemData } = event;

    let userSelection = {
      nameSurname: itemData.nameSurname,
      shiftUserId: fromUserSel.shiftUserId,
      anaUserId: itemData.anaUserId,
      anaUserRoleId: itemData.anaUserRoleId,
      day: itemData.day,
      shift: availabilitySubsetForRequestChange.shiftIndex,
      user: availabilitySubsetForRequestChange.userIndex,
    };

    setShiftUserSelection(userSelection);
  }

  function toggleChangeShiftIcon(bool) {
    let idxArray = htmlKeyForChangeShift.replace("hk_", "").split("_");
    if (!calendarSel.days[idxArray[0]]) return;

    let copyData = calendarSel;
    copyData.days[idxArray[0]].shifts[idxArray[1]].users[
      idxArray[2]
    ].showChangeRequest = bool;
    setCalendarSel(copyData);
  }

  function handleStepperPrevStep() {
    setStepSel(stepSel - 1);
    if (stepSel === 2) {
      setIsPersonManuallySelected(false);
      if (toUserSel) {
        calendarSel.days[toUserSel.day - 1].shifts[toUserSel.shift].users[
          toUserSel.user
        ].isSelected = false;
        setCalendarSel(calendarSel);
      }

      setToUserSel(null);
      toggleChangeShiftIcon(false);
      setStepperAdditionalInfo(null);
    }
  }

  function handleConfirmShiftChange() {
    if (!shiftUserSelection.nameSurname) return;
    setIsChangeShiftRequestConfirmDialogOpen(false);
    setToUserSel(shiftUserSelection);
    setStepperAdditionalInfo(shiftUserSelection.nameSurname);
  }

  return (
    <>
      {isFetchingCompleted && (
        <div className="flex-container-cal" style={{ marginTop: "1%" }}>
          <CalendarToolbar
            calData={calData}
            isMobile={isMobile}
            editor={editor}
            eventCalendarList={calendarEvents}
            calendarSel={calendarSel}
            isEditEnabled={isEditEnabled}
            isPublished={isPublished}
            hasDateExpired={hasDateExpired}
            vacantRequests={vacantRequests}
            myPendingVacantRequests={myPendingVacantRequests}
            isVacantSelectMode={isVacantSelectMode}
            pendingShiftRequestsCount={getNumberOfPendingShiftRequests()}
            defaultDate={defaultDate}
            maxDate={maxDate}
            t={props.t}
            onToggleEdit={() => setEditEnabled(!isEditEnabled)}
            onChangeShiftWithOtherUser={changeShiftWithOtherUser}
            onToggleVacantMode={handleToggleVacantMode}
            onOpenShiftRequests={() => setOpenCL(true)}
            onRefreshCalendar={refreshCalendar}
            onChangeShiftStatus={changeShiftStatus}
            onToggleSidePanel={() => setOpenSidePanel(!openSidePanel)}
            openSidePanel={openSidePanel}
            onPrintOnFile={printOnFile}
            onMonthChange={onMonthChange}
          />
          <div className="flex-row-cal" id="flexRowUpdate">
            <cite style={{ fontSize: "x-small" }}>
              {props.t("lastUpdate")}: {lastUpdate}
            </cite>
          </div>
          <div id="printCal" >
            {isVacantSelectMode && (
              <Alert severity="info" icon={<PersonAddIcon fontSize="inherit" />} sx={{mt: 1, mb: 1 }}>
                <strong>{props.t("Modalità candidatura attiva")}</strong>
                <br />
                • {props.t("Per candidarti seleziona un turno non assegnato compatibile con il tuo ruolo (data odierna o futura).")}
                <br />
                • {props.t("Per annullare clicca sull'icona del cestino nelle celle evidenziate in giallo.")}
                <br />
                • {props.t("Clicca di nuovo sull'icona nella barra in alto per uscire dalla modalità.")}
              </Alert>
            )}
            {calendarSel && shiftSel && availabilitySel && (
              isMobile ? printCalendarResponsive() : printCalendar()
            )}
          </div>
          {isChangeShiftSidebarVisible && (
              <ChangeShiftStepperPlus
                ref={stepperRef}
                fromUser={fromUserSel}
                toUser={toUserSel}
                additionalInfo={stepperAdditionalInfo}
                nextStep={() => {
                  setStepSel(stepSel + 1);
                  if (stepSel === 1) {
                    toggleChangeShiftIcon(true);
                  }
                }}
                prevStep={() => handleStepperPrevStep()}
                resetStep={() => resetChangeShift()}
                handleConfirmation={() => saveChangeShiftRequest()}
                onFullReset={() => stepperFullReset()}
                onPartialReset={() => stepperPartialReset()}
              />
            )}
          <ToastComponent
            id="toast_default"
            ref={toastRef}
            position={{ X: "Right", Y: "Bottom" }}
            title={toastInfo.title}
            content={toastInfo.content}
            cssClass={toastInfo.cssClass}
            icon={toastInfo.icon}
          />
          <ToastComponent
            ref={(toast) => {
              setToastObj(toast);
            }}
            id="toast_default"
            position={{ X: "Right", Y: "Bottom" }}
          />
        </div>
      )}
      { calendarSel && (
        <SummaryDialog112
            open={open}
            onClose={() => setOpen(false)}
            calendarId={selectedCaldendarId}
            year={calendarSel.year}
            month={calendarSel.month}
            apiUrl={apiUrl}
            t={props.t}
          />
      )
      }
      <ShiftAssignDialog
        dataSource={availabilityForceSel}
        titleContent={forceShiftSel}
        onChange={onForcedUserChanged}
        onOpen={onUserForcedOpen}
        onSubmit={forceActualShift}
        translate={props.t}
        isOpen={showForceDialog}
        handleClose={() => setShowForceDialog(false)}
      />
      <ShiftRequestsDialog
        outRequestDataSource={outRequestList}
        inRequestDataSource={inRequestList}
        onCommandClick={handleShiftRequestsDialogClick}
        senderRowDataBound={senderRowDataBound}
        recieverRowDataBound={recieverRowDataBound}
        handleClose={() => setOpenCL(false)}
        isOpen={openCL}
        translate={props.t}
      />
      <VacantShiftsAdminDialog
        dataSource={vacantRequests}
        users={allUserName}
        onCommandClick={handleVacantShiftAdminAction}
        handleClose={() => setOpenVacantCL(false)}
        isOpen={openVacantCL}
        translate={props.t}
      />
      <ShiftChangeDialog
          open={isShiftChangeConfirmDialogOpen}
          onClose={() => setIsShiftChangeConfirmDialogOpen(false)}
          onConfirm={handleChangeShiftRequest}
          requestType={changeShiftRequestData.requestType}
          rowData={changeShiftRequestData.rowData}  // ← NUOVO: passa i dettagli
          t={props.t}
        />
            
      <ShiftTransferDialog
        dataSource={availabilitySubsetForRequestChange.dataSource}
        isOpen={isChangeShiftRequestConfirmDialogOpen}
        isEditEnabled={isEditEnabled}
        handleDropdownChange={handleShiftChangeDropdown}
        handleConfirmation={handleConfirmShiftChange}
        handleClose={() => setIsChangeShiftRequestConfirmDialogOpen(false)}
        translate={props.t}
      />
      <VacantApplyDialog
        isOpen={openVacantDialog}
        onClose={() => setOpenVacantDialog(false)}
        onConfirm={handleConfirmVacantApplication}
        slotData={selectedVacantSlot}
        shiftsList={shiftSel}
        translate={props.t}
      />
      <VacantCancelDialog
        open={openVacantCancelDialog}
        onClose={() => {
          setOpenVacantCancelDialog(false);
          setSelectedVacantRequestToCancel(null);
        }}
        onConfirm={handleConfirmCancelVacantRequest}
        requestToCancel={selectedVacantRequestToCancel}
        t={props.t}
      />
      &nbsp;
      {isLoading && (
        <Box
          sx={{
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 9999,
          }}
        >
          <CircularProgress size={60} thickness={4} />
        </Box>
      )}
    </>
  );
}

export default withTranslation()(CalXlsPage);